<template>
  <article
    class="group flex h-full flex-col rounded-3xl border p-7 transition-all hover:-translate-y-1"
    :class="featured
      ? 'border-primary/30 bg-gradient-to-br from-primary/15 to-transparent'
      : 'border-text-main/10 bg-white hover:shadow-[0_24px_60px_-30px_rgba(24,22,16,0.35)]'"
  >
    <span
      class="flex size-12 items-center justify-center rounded-2xl transition-colors"
      :class="featured ? 'bg-primary text-text-main' : 'bg-primary/15 text-primary group-hover:bg-primary group-hover:text-text-main'"
    >
      <span class="material-symbols-outlined">{{ icon }}</span>
    </span>
    <h3 class="mt-5 text-lg font-bold text-text-main">{{ title }}</h3>
    <p class="mt-2 text-sm text-text-muted">{{ text }}</p>
  </article>
</template>

<script setup lang="ts">
defineProps<{ icon: string; title: string; text: string; featured?: boolean }>();
</script>
